module.exports = __webpack_public_path__ + "img/icon-chevron-left.4cd4a98d.svg";